import React from 'react'

import * as Partials from './partials'
import * as UI from '../components'
import { dataToArray, formatCoin } from '../helpers'

class ExpiredPurchase extends React.Component {
  render() {
    const { purchase = {}, storefront } = this.props;

    return (
      <div>
        <UI.Card>
          <UI.Text center weight="bold" size="large">
            Your purchase has expired!
          </UI.Text>

          <UI.Divider />

          <UI.Text center>
            We received{' '}
            {formatCoin(purchase.completedPayments, purchase.currency)} of{' '}
            {formatCoin(purchase.cost, purchase.currency)}
          </UI.Text>

          <UI.Divider hidden />

          <UI.Text center>
            <Partials.PaymentsList payments={dataToArray(purchase.payments)} />
          </UI.Text>

          <UI.Text center>
            If you would like to purchase more {storefront.tokenName}, click
            below. If you have any concerns about your purchase, please email us
            at help@coincart.co
          </UI.Text>

          <UI.Divider hidden />

          <UI.Text center>
            <UI.Button to="/">Purchase more {storefront.tokenName}</UI.Button>
          </UI.Text>
        </UI.Card>
      </div>
    )
  }
}

export default ExpiredPurchase



// WEBPACK FOOTER //
// ./src/screens/ExpiredPurchase.js